module.exports = __webpack_public_path__ + "static/media/cpp.2b2f3224.svg";